import { useEffect, useState } from 'react';
import PlaceholderImg from '../../../Images/HomePage/news-img-placeholder.png';
export const useNewsCard = (backgroundImage) => {
	const bgUrl = backgroundImage || PlaceholderImg;
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleOpenModal = () => {
		setIsModalOpen(true);
	};
	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	useEffect(() => {
		document.body.style.overflow = isModalOpen ? 'hidden' : 'auto';

		return () => {
			document.body.style.overflow = 'auto';
		};
	}, [isModalOpen]);
	return {
		bgUrl,
		handleOpenModal,
		handleCloseModal,
		isModalOpen,
	};
};
